<app-user-list (editUser)="editUser($event)"></app-user-list>